import {
    CREATE_DYEING_INWARD_MASTER_REQUEST,
    CREATE_DYEING_INWARD_MASTER_SUCCESS,
    CREATE_DYEING_INWARD_MASTER_FAILURE,
    DELETE_DYEING_INWARD_MASTER_REQUEST,
    DELETE_DYEING_INWARD_MASTER_SUCCESS,
    DELETE_DYEING_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE,
    FETCH_DYEING_INWARD_MASTER_REQUEST,
    FETCH_DYEING_INWARD_MASTER_SUCCESS,
    FETCH_DYEING_INWARD_MASTER_FAILURE,
    UPDATE_DYEING_INWARD_MASTER_REQUEST,
    UPDATE_DYEING_INWARD_MASTER_SUCCESS,
    UPDATE_DYEING_INWARD_MASTER_FAILURE,
    RESET_DYEING_INWARD_MASTER_INFO,
    CREATE_DYEING_INWARD_MASTER_FORM,
    UPDATE_DYEING_INWARD_MASTER_FORM,
    NAVIGATE_DYEING_INWARD_DETAILS,
    NAVIGATE_DYEING_INWARD_MASTER,
    FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_DYEING_INWARD,
    RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID,
    SET_END_DATE_DYEING_INWARD,
    SET_START_DATE_DYEING_INWARD,
    SET_UNIT_NAME_DYEING_INWARD
} from './dyeingInwardHeader.actionsType';

export const DYEING_INWARD_MASTER = 'dyeingInwardHeader';

let initialState = {
    loading: false,
    dyeingInwardHeader: [],
    pendingDyeingDc: [],
    activeKey: 1,
    dyeingInwardId: '',
    dyeingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,

        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleDyeingInwardData: {},
    isDyeingInwardDetails: false,
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let dyeingInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_DYEING_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST:
        case CREATE_DYEING_INWARD_MASTER_REQUEST:
        case UPDATE_DYEING_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST:
        case DELETE_DYEING_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardHeader: updatePayload
            };
        case FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingDyeingDc: updatePayload
            };
        case CREATE_DYEING_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                dyeingInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_DYEING_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_DYEING_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case RESET_DYEING_INWARD_MASTER_INFO:
            return {
                ...state,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                dyeingInwardId: '',
                activeKey: 1
            };
        case CREATE_DYEING_INWARD_MASTER_FORM:
        case UPDATE_DYEING_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                dyeingInwardHeaderForm: {
                    ...state.dyeingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_DYEING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case FETCH_DYEING_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE:
        case CREATE_DYEING_INWARD_MASTER_FAILURE:
        case UPDATE_DYEING_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE:
        case DELETE_DYEING_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID:
            return {
                ...state,
                dyeingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_DYEING_INWARD_DETAILS:
            return {
                ...state,
                isDyeingInwardDetails: true,
                singleDyeingInwardData: updatePayload.singleDyeingInwardData
            };
        case NAVIGATE_DYEING_INWARD_MASTER:
            return {
                ...state,
                isDyeingInwardDetails: false,
                goBack: false
            };
        case SET_UNIT_NAME_DYEING_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_DYEING_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_DYEING_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
